export default __webpack_public_path__ + "static/media/arrow-left.e0888798.svg";